import { render } from "./NeuroSurgery.vue?vue&type=template&id=5ffe22f4"
import script from "./NeuroSurgery.vue?vue&type=script&lang=ts"
export * from "./NeuroSurgery.vue?vue&type=script&lang=ts"
script.render = render

export default script